const AUTH_CHANNEL_NAME = 'nb_auth';
const LOGOUT_MESSAGE = 'LOGOUT';

type AuthBroadcastMessage = { type: typeof LOGOUT_MESSAGE };

let authChannel: BroadcastChannel | null = null;

function channel(): BroadcastChannel | null {
  if (typeof window === 'undefined' || !('BroadcastChannel' in window)) {
    return null;
  }

  authChannel ??= new BroadcastChannel(AUTH_CHANNEL_NAME);

  return authChannel;
}

export function broadcastLogout(): void {
  channel()?.postMessage({ type: LOGOUT_MESSAGE } satisfies AuthBroadcastMessage);
}

export function subscribeToLogout(callback: () => void): () => void {
  const currentChannel = channel();

  if (!currentChannel) {
    return () => {};
  }

  function handleMessage(event: MessageEvent<AuthBroadcastMessage>) {
    if (event.data?.type === LOGOUT_MESSAGE) {
      callback();
    }
  }

  currentChannel.addEventListener('message', handleMessage);

  return () => currentChannel.removeEventListener('message', handleMessage);
}
